import { render, staticRenderFns } from "./TempRankingPendingConfirmation.vue?vue&type=template&id=35c0ce0b&scoped=true&"
import script from "./TempRankingPendingConfirmation.vue?vue&type=script&lang=js&"
export * from "./TempRankingPendingConfirmation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35c0ce0b",
  null
  
)

export default component.exports